import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const withRouter = (Component) => {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    
    // Create a history object that mimics the old history API
    const history = {
      back: () => navigate(-1),
      goBack: () => navigate(-1),
      location,
      navigate,
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
    };

    // Create a match object that mimics the old match API
    const match = {
      params,
      isExact: location.pathname === params.path,
      path: location.pathname,
      url: location.pathname + location.search
    };

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        history={history}
        match={match}
        location={location}
      />
    );
  }

  // Set display name for debugging
  ComponentWithRouterProp.displayName = `WithRouter(${Component.displayName || Component.name || 'Component'})`;

  // Copy static methods and properties
  return Object.assign(ComponentWithRouterProp, Component);
};

export default withRouter; 